import { SectionHeading } from "@/components/shared/SectionHeading";
import { Reveal } from "@/components/shared/Reveal";
import { ArrowRight } from "lucide-react";
import { openPreRegister } from "@/lib/preRegisterModal";

export const FindADriver = () => (
  <section id="find-a-driver" data-testid="find-a-driver-section" className="py-20 md:py-28 bg-white">
    <div className="max-w-3xl mx-auto px-5 md:px-8 text-center">
      <SectionHeading
        eyebrow="For Owner Operators & Carriers"
        title="Need a Driver?"
        description="RelayRigs is building a network of qualified drivers for relief, temporary assignments, relays, and other transportation needs."
        align="center"
        testId="find-a-driver"
      />
      <Reveal delay={0.2}>
        <button
          onClick={() => openPreRegister("need_driver")}
          data-testid="join-requester-waitlist-cta"
          className="mt-9 inline-flex items-center gap-2 bg-rr-navy text-white font-bold px-8 py-4 rounded-full hover:bg-rr-orange transition-all hover:-translate-y-1"
        >
          Join the Requester Waitlist <ArrowRight size={18} />
        </button>
      </Reveal>
    </div>
  </section>
);
